import $ from 'jquery';

function smoothscroll(e, scrollTrigger) {
    var selector;
    if ($(scrollTrigger).attr('href') != undefined) {
        e.preventDefault();
        selector = $(scrollTrigger).attr('href');
    } else if ($(scrollTrigger).data('selector') != undefined) {
        selector = $(scrollTrigger).data('selector');
    } else {
        return;
    }

    var offset = 0;
    if ($(scrollTrigger).data('offset') != undefined) {
        offset = $(scrollTrigger).data('offset');
    }

    var animationDuration = 500;
    if ($(scrollTrigger).data('animduration') != undefined) {
        animationDuration = $(scrollTrigger).data('animduration');
    }

    $('html, body')
        .stop()
        .animate(
            {
                scrollTop: $(selector).offset().top - offset,
            },
            animationDuration,
            function () {
                $(window).trigger('smoothscroll:end');
            }
        );
}

$(function () {
    $(document).on('click', '.smoothscroll', function (e) {
        smoothscroll(e, this);
    });
});
